import { useSyncExternalStore } from 'react';

/**
 * Whether this browser has opened Stories yet, for the sidebar "New" tag (power-user review: the
 * tag never went away). localStorage can be blocked or empty (private window), so every access is
 * guarded; on failure the tag simply keeps showing.
 */
export const STORIES_SEEN_KEY = 'og-stories-seen';
const EVENT = 'og-stories-seen';

function read(): boolean {
  try {
    return window.localStorage.getItem(STORIES_SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markStoriesSeen(): void {
  try {
    if (window.localStorage.getItem(STORIES_SEEN_KEY) === '1') return;
    window.localStorage.setItem(STORIES_SEEN_KEY, '1');
  } catch {
    return;
  }
  window.dispatchEvent(new Event(EVENT));
}

function subscribe(onChange: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === STORIES_SEEN_KEY) onChange();
  };
  window.addEventListener(EVENT, onChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(EVENT, onChange);
    window.removeEventListener('storage', onStorage);
  };
}

export function useStoriesSeen(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
